import type { ThemeWithoutTokens } from '../theme.types';

export const dropdownTokens = (theme: ThemeWithoutTokens) =>
  ({
    dropdownOverlayPaddingY: theme.space.component.y.s,

    dropdownItemPaddingY: theme.space.component.y.s,
    dropdownItemPaddingX: theme.space.component.x.m,
    dropdownItemHoverBackgroundColor: theme.colors.border,
    dropdownItemFocusBackgroundColor: theme.colors.primary.alpha,
    dropdownItemHoverFocusedBackgroundColor: theme.palette.grey300,
  }) as const;
